import React from 'react';
import PostsSkeleton from './PostsSkeleton';
import { Skeleton } from '../Common/Skeleton';
import { useRouter } from 'next/router';
import RonTipsCardSkeleton from './RonTipsCardSkeleton';
import { cn } from '../../../utils';

export default function CategorySectionSkeleton({className}) {
  const router = useRouter();
  const path = router?.pathname;
  if (path.includes('/rons-tips')) {
    return (
      <div className='flex flex-col gap-6'>
        <RonTipsCardSkeleton />
      </div>
    );
  } else {
    return (
      <div className={cn('flex flex-col gap-6',className)}>
        <Skeleton className='h-[43px] w-[90%] max-w-[403px] md:w-[403px]' />
        <PostsSkeleton />
      </div>
    );
  }
}
